<template>
<div class="odr-align-horizontal-center">
    <div class="odr-align-horizontal-center__content">
        <slot> </slot>
    </div>
</div>
</template>

<script>
import '../styles/align-horizontal-center.scss'
export default {}
</script>
